import * as React from "react";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import DropDown from "../../../hiberUiKit/src/molecules/DropDown/DropDown";
import {LabelableProps} from "../../common/props/LabelableProps";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import {option} from "ts-option";
import {RewardsStatus} from "../../../model/partnerBrand/PartnerBrandRewardsData";

type Props = FormGroupProps<string> & PlaceholderProps & LabelableProps

export default class RewardsStatusFormGroup extends React.Component<Props, {}> {
	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().orNull}
					   customClass={"c-rewords-status-form-group"}>
				<DropDown items={Object.keys(RewardsStatus)}
						  itemToLabel={(item: any) => RewardsStatus[item]}
						  itemToId={(item: string) => item}
						  onSelect={this.onChange}
						  selectedItemId={this.props.field.getOptionalValue().orNull}/>
			</FormGroup>
		)
	}

	onChange = (item: string) => {
		this.props.onChange(this.props.field.updateValue(option(item)));
	}
}